import { gql } from "@apollo/client"

export const GET_SESSIONS = gql`
query GetSessionsByCondition($searchCriteria:String!,$searchId:UUID,  $first: Int,$after:String, $sessionType:SessionScreenType){
  sessionsByCondition (searchCriteria: $searchCriteria,searchId:$searchId,first:$first, after:$after,sessionType: $sessionType) {
    pageInfo {
      hasNextPage
      hasPreviousPage
      startCursor
      endCursor
    }
    totalCount
    edges{
      __typename
      node {
        id
        createdAt
        studentId
        student{
          firstName
          lastName  
        }
        type
        language
        category
        data
        person{
          id
          firstName
          lastName
        }
        location{
            id
            name
        }
      }
    }
  }
} 
`
